<template>
<div class="chapter">
<div class="inner_page">
<p class="center-b"><span><i>It shines in Paradise. It burns in Hell.</i><br/>—Gaston Bachelard, <i>The Psychoanalysis of Fire</i></span></p>
<p class="center-a"><span><i>I started hearing whispers from the people in the bedspread and in <br/>the window glass, and though I was a little embarrassed at first, I<br/>answered them, thinking, why deny anything?</i><br/>—William S. Burroughs, Jr., <i>Speed</i></span></p>
<p class="center-a"><span><i>The Bible never said anything about amphetamines</i>.<br/>—“Fast” Eddie Felson in <i>The Color of Money</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmater1.vue?0227fff8